export enum InsuranceSellContextEnum {
    PaymentPage = "payment",
    ExtrasPage = "extras",
}